import { post, get, form } from '../axios'

const api = `${process.env.VUE_APP_COL}/customer_category/mappings`

// 创建映射
export function customer_category_mappings_create_post(map, option) {
  return post(`${api}/create`, map, option).then(response => response)
}

// 分页查询映射
export function customer_category_mappings_page_post(map, option) {
  return post(`${api}/page`, map, option).then(response => response)
}

// 查询映射详情
export function customer_category_mappings_mappingId_get(map, option) {
  return get(`${api}/${map.mappingId}`, map, option).then(response => response)
}

// 复制映射
export function customer_category_mappings_mappingId_copy_post(map, option) {
  const { mappingId, ...data } = map
  return post(`${api}/${mappingId}/copy`, data, option).then(
    response => response
  )
}

// 查询可选对客三级类目
export function customer_category_mappings_mappingId_customerCategories_get(
  map,
  option
) {
  const { mappingId, ...params } = map
  return get(`${api}/${mappingId}/customer_categories`, params, option).then(
    response => response
  )
}

// 删除映射
export function customer_category_mappings_mappingId_delete_post(map, option) {
  return post(`${api}/${map.mappingId}/delete`, map, option).then(
    response => response
  )
}

// 批量映射
export function customer_category_mappings_mappingId_rules_batchUpsert_post(
  map,
  option
) {
  const { mappingId, ...data } = map
  return post(`${api}/${mappingId}/rules/batch-upsert`, data, option).then(
    response => response
  )
}

// 取消映射
export function customer_category_mappings_mappingId_rules_cancel_post(
  map,
  option
) {
  const { mappingId, ...data } = map
  return post(`${api}/${mappingId}/rules/cancel`, data, option).then(
    response => response
  )
}

// 查询映射规则
export function customer_category_mappings_mappingId_rules_list_get(
  map,
  option
) {
  return get(`${api}/${map.mappingId}/rules/list`, map, option).then(
    response => response
  )
}

// 新增或修改映射规则
export function customer_category_mappings_mappingId_rules_upsert_post(
  map,
  option
) {
  const { mappingId, ...data } = map
  return post(`${api}/${mappingId}/rules/upsert`, data, option).then(
    response => response
  )
}

// 切换映射状态
export function customer_category_mappings_mappingId_status_post(map, option) {
  return post(`${api}/${map.mappingId}/status`, map, option).then(
    response => response
  )
}

// 修改映射
export function customer_category_mappings_mappingId_update_post(map, option) {
  return post(`${api}/${map.mappingId}/update`, map, option).then(
    response => response
  )
}

// 导入并创建对客类目映射
export function customer_category_mappings_import_post(map, option) {
  return form(`${api}/import`, map, option).then(response => response)
}

// 异步导出对客类目映射
export function customer_category_mappings_mappingId_export_post(map, option) {
  const { mappingId, ...params } = map
  return post(`${api}/${mappingId}/export`, params, option).then(
    response => response
  )
}
